module.exports = __webpack_public_path__ + "static/myob-stats-2fd63dd2f744a05c66aa4be19bd01a62.png";